export default __webpack_public_path__ + "static/PMG_EGIB_HOHH_PW_AGENCY_ENG-314b2b71ed5a031452bda8b559d0e30b.pdf";